/**
 * 文件说明:
 *
 * hz hooks
 *
 * ----------------------------------------
 * 创建用户: leo
 */
import {createUseSafeImmer, createUseImmer} from '@huzan/hz-react-hooks'
import produce from 'immer'

export const useSafeImmer = createUseSafeImmer(produce)

export const useImmer = createUseImmer(produce)

export * from '@huzan/hz-react-hooks'

export * from './business/use-auth'

export * from './business/use-hz-doc-title'

export * from './business/use-multi-agent'

export * from './business/use-page-main-config'
